import { userRoleType } from '@models/auth/authModel';
import { IAPPResponse } from '@models/scraperModel/appModel';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getLocaleValueForFlag, getLanguageCode } from '@utils/common/language';
import * as thuks from './layoutThunk';
import { LayoutDTO } from '@models/layout/layoutModel';
import { IResponseRegisteredAppInfo } from '@models/manager/service/serviceModel';

const slice = createSlice({
  name: 'LAYOUT',
  initialState: {
    // 내가 등록한 앱중 선택된 앱
    myAppObj: null as LayoutDTO.MyApp,
    // 내가 등록한 앱리스트
    myAppList: [] as LayoutDTO.MyApp[],
    // 내가 등록한 앱중 선택된 앱의 등록된 경쟁자앱들
    comptitorApps: [] as LayoutDTO.MyApp[], //TODO: 추후 competitor 정책 정해지면 변경하기
    // 현재 선택된 앱 (내가 등록한 앱중 선택된 앱 OR 해더검색앱)
    selectedAppInfo: null as LayoutDTO.SelectedMyApp | LayoutDTO.SelectedSearchedApp,
    // 해더검색앱
    headerSearchedAppInfo: null as any,

    isLeftMenu: false,
    searchResult: [],
    selectedRole: 'user' as userRoleType,

    //selectedAppInfo: null as IAPPResponse, // 기존의 searchedAppInfo
    similarAppsInfo: null as IAPPResponse[], //selectedApp 선택 시
    isSelectedApp: false, // TODO: selectedAppInfo 이장작업 끝난 후 삭제처리 할것
    isMobileSearch: false,
    selectedCountry: getLocaleValueForFlag(),
    selectedLanguage: getLanguageCode(getLocaleValueForFlag()),
  },
  reducers: {
    leftMenuToggle: (state, { payload: { data } }) => {
      state.isLeftMenu = !state.isLeftMenu;
    },
    // 검색 후 리스트 불러오기
    setSearchResult: (state, { payload: { data } }) => {
      state.searchResult = data;
      //state.isShowSearchList = true;
    },

    // myAppList 에서 선택한 앱을 myAppObj로 처리
    setMyAppObj: (state, action: PayloadAction<LayoutDTO.MyApp>) => {
      // 해당 리스트에서 앱을 선택하지 않을 경우 첫번째 앱 선택
      const { payload } = action;
      const appObjIndex = state.myAppList.findIndex((item) => item.appSeq === payload.appSeq);
      if (appObjIndex > -1) {
        state.myAppObj = payload;
      } else {
        state.myAppObj = state.myAppList[0] ?? null;
      }
    },

    // TODO: 추후 삭제처리
    selectRole: (state, { payload: { data } }) => {
      //state.isLogin = true;
      state.selectedRole = data;
    },
    //
    setHeaderSearchedAppInfo: (state, { payload: { data, isSelectedApp } }) => {
      state.headerSearchedAppInfo = data;
      state.isSelectedApp = isSelectedApp;
    },
    // selectedApp 이 null 일때 similarAppsInfo 도 null 처리를 해준다.
    setSimilarAppsInfo: (state, { payload: { data } }) => {
      state.similarAppsInfo = data;
    },

    setMobileSearchToggle: (state, action: PayloadAction<{ toggle: boolean; initValue: boolean }>) => {
      const { payload } = action;
      const { toggle, initValue } = payload;
      if (toggle) {
        state.isMobileSearch = !state.isMobileSearch;
      } else {
        state.isMobileSearch = initValue;
      }
    },

    // 검색시 국가선택 설정
    setCountryFlag: (state, action: PayloadAction<string>) => {
      console.log('action: ', action);
      const { payload } = action;
      state.selectedCountry = payload;
    },

    // 검색시 언어선택 설정
    setLanguage: (state, action: PayloadAction<string>) => {
      const { payload } = action;
      state.selectedLanguage = payload;
    },

    // selectedAppInfo 설정
    setSelectedAppInfo: (state, action: PayloadAction<LayoutDTO.SelectedMyApp | LayoutDTO.SelectedSearchedApp>) => {
      const { payload } = action;
      state.selectedAppInfo = payload;
    },
  },
  extraReducers: {
    // [GET] 나의 앱 리스트 조회 My Apps 조회.
    [thuks.getMyAppsThunk.fulfilled.type]: (state, { payload }) => {
      // 에러 처리
      if (typeof payload === 'string') {
        state.myAppList = [];
        state.myAppObj = null;
      } else if (payload.length > 0) {
        state.myAppList = payload;
        state.myAppObj = payload[0];
      }
    },
    [thuks.getMyAppsThunk.rejected.type]: (state, { payload }) => {
      console.log('reject payload: ', payload);
      state.myAppList = [];
      state.myAppObj = null;
    },
    // [GET] 경쟁자 앱 리스트 요청
    [thuks.getComptitorAppsThunk.fulfilled.type]: (state, { payload }) => {
      if (typeof payload === 'string') {
        state.comptitorApps = [];
      } else if (payload.length > 0) {
        state.comptitorApps = payload;
      }
    },
    [thuks.getComptitorAppsThunk.rejected.type]: (state, { payload }) => {
      state.comptitorApps = [];
    },
    // [PUT] 요청 :경쟁자 앱 추가앱리스트, 삭제앱리스트 보내기
    //       응답 :업데이트 competitorApps 리스트 받고 적용시키기
    [thuks.putCompetitorAppsThunk.fulfilled.type]: (state, { payload }) => {
      if (typeof payload === 'string') {
        // 기존 state 유지..
      } else if (payload.length > 0) {
        state.comptitorApps = payload;
      }
    },
    [thuks.putCompetitorAppsThunk.rejected.type]: (state, { payload }) => {
      // 기존 state 유지..
    },
    // [DELETE] 요청 :AppProfile 의 팝업에서 경쟁자 앱 1개씩 삭제처리
    //          응답 :result: boolean, message: string (삭제 성공 시 comptitorApps 에서 filter로 제거시키기)
    [thuks.deleteSingleCompetitorApp.fulfilled.type]: (
      state,
      action: PayloadAction<thuks.reqDeleteMyCompetitorAppType>
    ) => {
      const { payload } = action;
      // 삭제처리
      state.comptitorApps = state.comptitorApps.filter((item) => {
        if (item.appId === payload.competitorAppId && item.providerType === payload.comprtitorProviderType) {
          return false;
        }
        return true;
      });
    },
    [thuks.deleteSingleCompetitorApp.rejected.type]: (
      state,
      action: PayloadAction<{ result: boolean; message: string }>
    ) => {
      const { payload } = action;
    },
    // [GET] 헤더에서 검색한 앱 정보 선택 시
    [thuks.getHeaderSearchedAppInfo.fulfilled.type]: (state, action: PayloadAction<IAPPResponse>) => {
      const { payload } = action;
      state.headerSearchedAppInfo = payload;
    },
    [thuks.getHeaderSearchedAppInfo.rejected.type]: (
      state,
      { error: { code, message, name, stack }, meta: { requestStatus } }
    ) => {
      state.headerSearchedAppInfo = null;
    },
    // 헤더에서 검색한 앱의 similar App List 가져오기
    [thuks.getSimilarAppsList.fulfilled.type]: (state, action: PayloadAction<IAPPResponse[]>) => {
      const { payload } = action;
      state.similarAppsInfo = payload;
    },
    [thuks.getSimilarAppsList.rejected.type]: (
      state,
      { error: { code, message, name, stack }, meta: { requestStatus } }
    ) => {
      state.similarAppsInfo = null;
    },
  },
});

export const layoutActions = slice.actions;
export const layoutSliceName = slice.name;
export default slice.reducer;
